import { useProjectState } from '@common/git/Project/hooks';
import { QueryKeys } from '@common/queries/common';
import { projectDetailQuery } from '@common/queries/project';
import { useGraphQlQuery } from 'frontend/core/src/data/util';

export const useProjectTeamId = () => {
  const { projectId } = useProjectState();
  const { data: projectData } = useGraphQlQuery(
    [QueryKeys.ProjectDetail, { projectId }],
    projectDetailQuery,
    { enabled: Boolean(projectId) },
    { projectId }
  );

  return projectData?.Project?.team?._id;
};
